import React from 'react'
import Highlight from '@paintscout/ui/components/Highlight'
import ActivityTitle from '../ActivityTitle'
import ActivityFooter from '../ActivityFooter'
import type { ActivityTypeComponentProps } from '../Activity'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

import ActivityOwner from '../ActivityOwner'
import QuoteLabel from '../QuoteLabel'
import ActivityDot from '../ActivityDot'

export default function QuoteInvoicedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props

  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        {showDocTypeDetails ? (
          <>
            <QuoteLabel activity={activity} /> was <Highlight>Invoiced</Highlight>
          </>
        ) : (
          <>
            <Highlight>Invoiced</Highlight>
          </>
        )}
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
